/**
 * Dialog Module
 * Otwarcie/zamknięcie dialogu z backdrop (HTML na stronie, nie generowany JS-em)
 *
 * Trigger HTML:  <button data-dialog-open="dialog-id">Otwórz</button>
 * Close HTML:   <button data-dialog-close>Anuluj</button>
 * Dialog HTML:  <div class="dialog-backdrop" id="dialog-id">...</div>
 *
 * API:
 *   Dialog.open('dialog-id');
 *   Dialog.close('dialog-id');
 */

(function () {
    'use strict';

    var BACKDROP_SELECTOR = '.dialog-backdrop';
    var CLOSE_SELECTOR = '.dialog__close';
    var CLOSE_TRIGGER_SELECTOR = '[data-dialog-close]';
    var TRIGGER_SELECTOR = '[data-dialog-open]';
    var ACTIVE_CLASS = 'is-active';
    var DISMISSING_CLASS = 'is-dismissing';
    var BODY_LOCK_CLASS = 'dialog-open';

    var currentId = null;

    /**
     * Otwórz dialog po ID
     */
    function open(id) {
        var backdrop = document.getElementById(id);
        if (!backdrop) return;

        // Zamknij poprzedni natychmiast jeśli otwarty
        if (currentId && currentId !== id) {
            closeImmediate(currentId);
        }

        currentId = id;

        // Scroll lock
        document.body.classList.add(BODY_LOCK_CLASS);

        // Listener Escape
        document.addEventListener('keydown', handleKeydown);

        // Force reflow
        void backdrop.offsetHeight;

        backdrop.classList.add(ACTIVE_CLASS);

        // Focus na dialog
        var dialog = backdrop.querySelector('.dialog');
        if (dialog) {
            dialog.setAttribute('tabindex', '-1');
            dialog.focus();
        }
    }

    /**
     * Zamknij dialog z animacją
     */
    function close(id) {
        var backdrop = document.getElementById(id || currentId);
        if (!backdrop) return;

        backdrop.classList.remove(ACTIVE_CLASS);
        backdrop.classList.add(DISMISSING_CLASS);

        var dialog = backdrop.querySelector('.dialog');
        if (dialog) {
            dialog.addEventListener('transitionend', function handler() {
                dialog.removeEventListener('transitionend', handler);
                finishClose(backdrop);
            });
        }

        // Fallback — usuń po max transition time
        setTimeout(function () {
            finishClose(backdrop);
        }, 400);
    }

    /**
     * Natychmiastowe zamknięcie (bez animacji)
     */
    function closeImmediate(id) {
        var backdrop = document.getElementById(id);
        if (!backdrop) return;
        finishClose(backdrop);
    }

    /**
     * Finalizacja zamknięcia
     */
    function finishClose(backdrop) {
        backdrop.classList.remove(ACTIVE_CLASS);
        backdrop.classList.remove(DISMISSING_CLASS);

        if (currentId === backdrop.id) {
            currentId = null;
        }

        // Scroll unlock
        document.body.classList.remove(BODY_LOCK_CLASS);

        // Usuń listener
        document.removeEventListener('keydown', handleKeydown);
    }

    /**
     * Obsługa klawisza Escape
     */
    function handleKeydown(e) {
        if (e.key === 'Escape' && currentId) {
            close(currentId);
        }
    }

    /**
     * Init — podpięcie eventów delegate
     */
    function init() {
        // Trigger open — delegacja na document
        document.addEventListener('click', function (e) {
            // Trigger open
            var trigger = e.target.closest(TRIGGER_SELECTOR);
            if (trigger) {
                e.preventDefault();
                var dialogId = trigger.getAttribute('data-dialog-open');
                if (dialogId) {
                    open(dialogId);
                }
                return;
            }

            // Close button (.dialog__close lub [data-dialog-close])
            var closeBtn = e.target.closest(CLOSE_SELECTOR) || e.target.closest(CLOSE_TRIGGER_SELECTOR);
            if (closeBtn && currentId) {
                close(currentId);
                return;
            }

            // Backdrop click
            var backdrop = e.target.closest(BACKDROP_SELECTOR);
            if (backdrop && e.target === backdrop && currentId) {
                close(currentId);
            }
        });
    }

    // Init
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Globalne API
    window.Dialog = {
        open: open,
        close: close
    };
})();
